import { Box, Button, ModalProps, VStack } from "@chakra-ui/react";
import CopyInput from "components/CopyInput";
import EtherAmount from "components/EtherAmount";
import EthIcon from "components/EthIcon";
import HoneyIcon from "components/HoneyIcon";
import SimplePopup from "components/SimplePopup";
import WalletAsset from "components/WalletAsset";
import { ethUniswqpUrl, honeyUniswapUrl } from "config";
import useAssets from "hooks/useAssets";
import useConnectedAccount from "hooks/useConnectedAccount";
import useTranslate from "hooks/useTranslate";
import { useNavigate } from "react-router-dom";

type WalletPopupProps = Omit<ModalProps, "children">;

const WalletPopup = (props: WalletPopupProps) => {
  const navigate = useNavigate();
  const translate = useTranslate();
  const [address, disconnect] = useConnectedAccount();
  const { balance, honeyBalance } = useAssets();

  const handleDisconnect = () => {
    disconnect();
    navigate("/");
  };

  return (
    <SimplePopup size="sm" title={translate("walletPopup:title")} {...props}>
      <Box px="3" pb="2">
        <CopyInput value={address || ""} mt="6" mb="6" />

        <VStack spacing="2px" mb="6">
          <WalletAsset
            py="4"
            icon={EthIcon}
            value={<EtherAmount amount={balance} />}
          >
            <Box pr="3">
              <Button as="a" href={ethUniswqpUrl} size="xs" variant="outline">
                {translate("common:buy")}
              </Button>
            </Box>
          </WalletAsset>

          <WalletAsset
            py="4"
            icon={HoneyIcon}
            value={<EtherAmount amount={honeyBalance} />}
          >
            <Box pr="3">
              <Button as="a" href={honeyUniswapUrl} size="xs" variant="outline">
                {translate("common:buy")}
              </Button>
            </Box>
          </WalletAsset>
        </VStack>

        <Button
          onClick={handleDisconnect}
          variant="solid"
          colorScheme="dark"
          w="full"
        >
          {translate("common:disconnect")}
        </Button>
      </Box>
    </SimplePopup>
  );
};

export default WalletPopup;
